<mat-toolbar class="mat-elevation-z8 tool-bar">
    <button mat-icon-button *ngIf="sidenav.mode === 'over'" (click)="sidenav.toggle()">
        <mat-icon *ngIf="!sidenav.opened">
            menu
        </mat-icon>
        <mat-icon *ngIf="sidenav.opened">
            close
        </mat-icon>
    </button>
    Golden Express
    <!-- <button class="logout-button">Logout</button> -->
</mat-toolbar>

<mat-sidenav-container>
    <mat-sidenav #sidenav="matSidenav" class="mat-elevation-z8">

        <!-- <mat-divider></mat-divider> -->
        <button mat-button (click)="showGeneralPage()" class="menu-button">
            <mat-icon>settings</mat-icon>
            <span>Global Settings</span>
        </button>
        <button mat-button (click)="showEditDelivery()" class="menu-button">
            <mat-icon>directions_car</mat-icon>
            <span>Delivery</span>
        </button>
        <button mat-button (click)="showEditCollection()" class="menu-button">
            <mat-icon>directions_walk</mat-icon>
            <span>Collection</span>
        </button>
        <!-- <button mat-button (click)="showReservationsPage()" class="menu-button">
            <mat-icon>event_seat</mat-icon>
            <span>Reservations</span>
        </button> -->
        <button mat-button (click)="showReportsPage()" class="menu-button">
            <mat-icon>library_books</mat-icon>
            <span>Reports</span>
        </button>
        <!-- <button mat-button (click)="showInvoicesPage()" class="menu-button">
            <mat-icon>library_books</mat-icon>
            <span>Invoices</span>
        </button> -->
        <!-- <mat-divider></mat-divider>

        <button mat-button class="menu-button">
            <mat-icon>help</mat-icon>
            <span>Help</span>
        </button> -->

    </mat-sidenav>
    <mat-sidenav-content>
        <div class="content mat-elevation-z8">
            <app-edit-delivery *ngIf="showDelivery"></app-edit-delivery>
            <app-edit-collection *ngIf="showCollection"></app-edit-collection>
            <app-generate-invoice *ngIf="showInvoices"></app-generate-invoice>
            <app-generate-report style="width: 100%;" *ngIf="showReports"></app-generate-report>
            <app-reservation-overrides *ngIf="showReservations"></app-reservation-overrides>
            <app-general-shop *ngIf="showGeneral"></app-general-shop>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>